import React from "react";
import ContentLoader from "react-content-loader";

function TableLoader(props) {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <ContentLoader
        speed={2}
        viewBox="0 0 1000 400"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        {...props}
      >
        <rect x="50" y="50" rx="1" ry="1" width="160" height="50" />
        <rect x="235" y="50" rx="1" ry="1" width="160" height="50" />
        <rect x="420" y="50" rx="1" ry="1" width="160" height="50" />
        <rect x="605" y="50" rx="1" ry="1" width="160" height="50" />
        <rect x="790" y="50" rx="1" ry="1" width="160" height="50" />

        <rect x="50" y="120" rx="1" ry="1" width="900" height="35" />
        <rect x="50" y="170" rx="1" ry="1" width="900" height="35" />
        <rect x="50" y="220" rx="1" ry="1" width="900" height="35" />
        <rect x="50" y="270" rx="1" ry="1" width="900" height="35" />
        <rect x="50" y="320" rx="1" ry="1" width="900" height="35" />
      </ContentLoader>
    </div>
  );
}

export default TableLoader;
